<template>
  <div class="password-page">
    <new-password-request-form v-if="mode === 'requestNew'"></new-password-request-form>
    <new-password-form v-if="mode === 'reset'" :code="code"></new-password-form>
  </div>
</template>

<style lang="scss" scoped>
.password-page {
  height: 100vh;
}
</style>

<script lang="ts">
import { defineComponent } from 'vue'

import NewPasswordForm from '@/client/features/password/new_password_form'
import NewPasswordRequestForm from '@/client/features/password/new_password_request_form'

export default defineComponent({
  components: {
    NewPasswordRequestForm,
    NewPasswordForm
  },
  data() {
    return {
      mode: '',
      code: ''
    }
  },
  created() {
    const { mode, code } = this.$route.query
    // 同じクエリが複数あると配列になる。その場合はクエリがないものとして扱う
    this.mode = typeof mode === 'string' ? mode : ''
    this.code = typeof code === 'string' ? code : ''
    if (this.mode !== 'reset' && this.mode !== 'requestNew') {
      this.$router.push('/login')
    }
    if (this.mode === 'reset' && !this.code) {
      this.$router.push('/login')
    }
  }
})
</script>
